import { AxiosError } from "axios";
function getResponseDataMessage(data) {
    if (typeof data !== "object" || data === null || !("message" in data)) {
        return undefined;
    }
    const message = data.message;
    return typeof message === "string" ? message : undefined;
}
export function getHttpStatus(error) {
    if (error instanceof AxiosError) {
        return error.response?.status;
    }
    if (typeof error === "object" && error !== null && "response" in error) {
        const status = error.response?.status;
        return typeof status === "number" ? status : undefined;
    }
    return undefined;
}
export function getHttpResponseMessage(error) {
    if (error instanceof AxiosError) {
        return getResponseDataMessage(error.response?.data);
    }
    if (typeof error === "object" && error !== null && "response" in error) {
        return getResponseDataMessage(error.response?.data);
    }
    return undefined;
}
export function isAuthHttpError(error) {
    const status = getHttpStatus(error);
    return status === 401 || status === 403;
}
